import { notify } from "../api/photoshop";
import { useGlobalStore } from "../globalStore";
import { useListenFromRenderer } from "../message";

export function useListenDevModeMessage() {
	useListenFromRenderer([
		{
			key: "devMode",
			onMessage: (msg) => {
				const { isDev } = msg.values;
				useGlobalStore.getState().setIsDevServer(isDev);
				notify(`Dev Mode : ${isDev ? "ON" : "OFF"}`);
			},
		},
	]);
}
